import {getData} from "./http-request-utils";
import {httpDelete, httpGet, httpPost} from "./http-functions";
import config from "../config";

export const createSupportUnit = async ({organizationUnitId}: any) => {
    const url = `${config.api}/support-units`
    const resp = await httpPost(url, {organizationUnitId});
    return getData(resp).supportUnit;
};

export const getSupportUnit = async ({organizationUnitId}: any) => {
    const url = `${config.api}/support-units/search?organizationUnitId=${organizationUnitId}`;
    const resp = await httpGet(url);
    return getData(resp).supportUnit;
}

export const addSupportedUnit = async ({supportUnitId, organizationId}: any) => {
    const url = `${config.api}/support-units/${supportUnitId}/supported-units`
    const resp = await httpPost(url, {organizationId});
    return getData(resp).succeed;
};

export const getSupportedUnits = async ({supportUnitId}: any) => {
    const url = `${config.api}/support-units/${supportUnitId}/supported-units`
    const resp = await httpGet(url);
    return getData(resp).supportedUnits;
};

export const removeSupportedUnit = async (supportUnitId: number, supportedUnitId: number) => {
    const url = `${config.api}/support-units/${supportUnitId}/supported-units/${supportedUnitId}`;
    const resp = await httpDelete(url);
    return getData(resp);
};

export const getAvailableSupportUnitCountries = async (supportUnitId: number) => {
    const url = `${config.api}/support-units/${supportUnitId}/countries`;
    const resp = await httpGet(url);
    return getData(resp);
};

export const setSupportUnitCountry = async (supportUnitId: number, countryId: number) => {
    const url = `${config.api}/support-units/${supportUnitId}/country`;
    const resp = await httpPost(url, {countryId});
    return getData(resp).success;
}

export const getSupportUnitCountry = async (supportUnitId: number) => {
    const url = `${config.api}/support-units/${supportUnitId}/country`;
    const resp = await httpGet(url);
    return getData(resp);
}

export const getRootSupportOrganizationUnit = async () => {
    const url = `${config.api}/support-units/root-unit`;
    const resp = await httpGet(url);
    return getData(resp);
}
